module.exports = __webpack_public_path__ + "static/media/BG-signup.89d4bdd8.jpg";